import styled, { keyframes } from "styled-components";

/* Deal-banner redesign shell — the `.lg-bnr` card from the VERO1 checklist
   design context (Spec.dc.html, "VERO1 Checklist Design Context Latest").
   Every value below mirrors a spec `.lg-*` rule 1:1. The shell is content-
   agnostic: PR-A ships the frame + slots, PR-B (VERO1) fills the eyebrow /
   verdict / meta / strip. Gated behind use-deal-summary-redesign-PRODUCT-1270. */

/* .lg-bnr{width:1180px;background:#2A2540;border-radius:14px;overflow:hidden;
   box-shadow:0 18px 50px -22px rgba(45,41,67,.5)} — width is fluid here (the
   card fills the app-summary column) rather than the fixed 1180px mock. */
export const Banner = styled.div<{ $docked?: boolean }>`
  width: 100%;
  background: #2a2540;
  /* the factor-cards sheet docks below as the unit's white bottom section
     (spec draws band, verdict row, strip and cards as one .lg-bnr card) */
  border-radius: ${({ $docked }) => ($docked ? "14px 14px 0 0" : "14px")};
  overflow: hidden;
  box-shadow: 0 18px 50px -22px rgba(45, 41, 67, 0.5);
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 26px;
  padding: 20px 26px;
  flex-wrap: wrap;
  & > * {
    min-width: 0;
  }
`;

/* .lg-slot{flex:1;max-width:560px} — paired (two labelled slots, spec
   "after leasing enacts a decision"): flex:0 0 auto;max-width:300px */
export const Slot = styled.div<{ $paired?: boolean }>`
  ${({ $paired }) =>
    $paired
      ? "flex: 0 0 auto; max-width: 300px;"
      : "flex: 1; max-width: 560px;"}
`;

/* the hairline between paired slots: 1px × 56px, rgba(255,255,255,.14) */
export const SlotDivider = styled.div`
  width: 1px;
  height: 56px;
  background: rgba(255, 255, 255, 0.14);
  flex: 0 0 auto;
`;

export const Eyebrow = styled.div`
  font: 600 10.5px "Work Sans", sans-serif;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #a9a3c9;
`;

export const Verdict = styled.div<{ $color?: string }>`
  font: 600 26px "Work Sans", sans-serif;
  letter-spacing: 0.03em;
  line-height: 1.1;
  margin-top: 3px;
  text-transform: uppercase;
  ${({ $color }) => ($color ? `color: ${$color};` : "color: #C8C3DC;")}
`;

/* verdict placeholder while the deal payload is still loading — .lg-val
   geometry, shimmering instead of empty */
const pulse = keyframes`
  0%, 100% { opacity: 0.55; }
  50% { opacity: 1; }
`;

export const VerdictSkeleton = styled.div`
  width: 180px;
  height: 26px;
  margin-top: 3px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.08);
  animation: ${pulse} 1.4s ease-in-out infinite;
`;

/* .lg-meta{font:300 12.5px/1.5 'Work Sans';color:#A9A3C9;margin-top:4px} */
export const Meta = styled.div`
  font: 300 12.5px/1.5 "Work Sans", sans-serif;
  color: #a9a3c9;
  margin-top: 4px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
  margin-left: auto;
`;

/* .lg-strip{background:#38335A;border-top:1px solid rgba(255,255,255,.08);
   padding:18px 26px} — the dark rules band below the row ("Why this
   recommendation" / "Waiting on the applicant"). Available to strip content;
   the shell places strip content bare (the internal-only hold band carries
   its own light chrome). */
export const Strip = styled.div`
  background: #38335a;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 18px 26px;
`;
